import React, { useEffect, useState } from "react";
import { MwButton, MwSpinnerButton } from "../../ui";
import CardHeadeWithActions from "../../ui/CardHeadeWithActions";
import GroupForm from "./GroupForm";
import { langObjType, objLangTextHandler, LangArrayToObjKeyValue } from "../../../utils/global";
import { useCurrent, useFetch, usePut } from "../../../hooks";
import { useTranslation } from "react-i18next";
import { invalidateFetchCache } from "../../../hooks/useFetch";

const EditGroup = ({ id, onHide, setMode }) => {
  const { currentTenantId, currentCompanyId, currentBranchId, currentLangList, currentLangId } =
    useCurrent();
  const [t] = useTranslation("global");
  const [errors, setErrors] = useState({});
  const groupShowUrl = `${process.env.REACT_APP_Auth_API_BASE_URL}/customers/groups/show/${id}`;
  const { data: groupResult, loading: loadingGroup, fetchData: fetchGroupData } = useFetch(
    groupShowUrl,
    false
  );
  const { data: resultPut, putData } = usePut();
  const [formLang, setFormLang] = useState(currentLangId);
  const [minDelayDone, setMinDelayDone] = useState(false);
  const [isFormReady, setIsFormReady] = useState(false);

  useEffect(() => {
    setIsFormReady(false);
    setMinDelayDone(false);
    invalidateFetchCache(groupShowUrl);
    fetchGroupData();
    const timer = setTimeout(() => setMinDelayDone(true), 800);
    return () => clearTimeout(timer);
  }, [groupShowUrl, fetchGroupData]);

  const [groupName, setGroupName] = useState(langObjType());
  const [groupDesc, setGroupDesc] = useState(langObjType());
  const [isActive, setIsActive] = useState(true);

  const formValidate = () => {
    let errorObj = {};
    if (!groupName[currentLangId]) {
      errorObj = { ...errorObj, [`groupName.${currentLangId}`]: t("customers.groupNameRequired") };
    }
    if (Object.keys(errorObj).length !== 0) {
      setErrors(errorObj);
      return true;
    }
    return false;
  };

  const saveHandler = () => {
    if (formValidate()) return;
    const _data = {
      groupName: objLangTextHandler(groupName),
      groupDesc: objLangTextHandler(groupDesc),
      isActive,
      tenantId: currentTenantId,
      companyId: currentCompanyId,
      branchId: currentBranchId,
    };
    putData(`${process.env.REACT_APP_Auth_API_BASE_URL}/customers/groups/update/${id}`, _data);
  };

  const cancelHandle = () => {
    onHide ? onHide() : setMode("List");
  };

  useEffect(() => {
    if (resultPut) {
      const groupsListUrl =
        currentTenantId && currentCompanyId && currentBranchId
          ? `${process.env.REACT_APP_Auth_API_BASE_URL}/customers/groups/${currentTenantId}/${currentCompanyId}/${currentBranchId}`
          : null;
      invalidateFetchCache(groupsListUrl);
      cancelHandle();
    }
  }, [
    resultPut,
    currentTenantId,
    currentCompanyId,
    currentBranchId,
    onHide,
    setMode,
  ]);

  useEffect(() => {
    if (groupResult?.data) {
      setGroupName(LangArrayToObjKeyValue(groupResult.data.groupName));
      setGroupDesc(LangArrayToObjKeyValue(groupResult.data.groupDesc));
      setIsActive(Boolean(groupResult.data.isActive));
      setIsFormReady(true);
    }
  }, [groupResult]);

  return (
    <div className={`${onHide && "p-5"}`}>
      <CardHeadeWithActions title={t("customers.editGroup")}>
        {onHide && (
          <MwButton inGroup={true} type="cancelBtn" onClick={cancelHandle}>
            {t("customers.cancel")}
          </MwButton>
        )}
        <MwButton inGroup={true} type="cancelBtn" onClick={() => setMode("List")}>
          {t("customers.customerGroupsList")}
        </MwButton>
        <MwButton actionType={`button`} inGroup={true} onClick={saveHandler} type="saveBtn">
          {t("customers.save")}
        </MwButton>
      </CardHeadeWithActions>
      {!isFormReady || loadingGroup || !minDelayDone ? (
        <div className="py-12">
          <MwSpinnerButton withLabel={false} isFullCenter={true} />
        </div>
      ) : (
        <GroupForm
          currentLangList={currentLangList}
          formLang={formLang}
          setFormLang={setFormLang}
          errors={errors}
          groupName={groupName}
          setGroupName={setGroupName}
          groupDesc={groupDesc}
          setGroupDesc={setGroupDesc}
          isActive={isActive}
          setIsActive={setIsActive}
        />
      )}
    </div>
  );
};

export default EditGroup;
